import React from 'react';
import cn from 'classnames';
import Dropdown from 'components/Common/Dropdown/Dropdown';
import getSelectedAttributeValue from 'utils/attributes/getSelectedAttributeValue';
import { ProductAttributeSelectorProps } from '../ProductAttributeSelector';
import styles from './ProductAttributeDropdownSelectorPremium.module.scss';

const ProductAttributeDropdownSelectorPremium = ({ selector, options, onClick }: ProductAttributeSelectorProps) => {
  if (!options.some((option) => !option.disabled)) {
    return null;
  }
  return (
    <div className={styles.dropdownSelector}>
      <div className={styles.selectorName}>{selector.name}</div>
      <div className={styles.options}>
        <Dropdown
          value={getSelectedAttributeValue(options) || ''}
          classNames={{
            dropdown: styles.dropdown,
            currentValue: styles.dropdownCurrentValue,
            options: styles.dropdownOptions,
          }}
        >
          {options.map(
            (option) =>
              !option.disabled && (
                <div
                  data-type="product-page-selector-option"
                  data-attribute-type-name={selector.name}
                  data-attribute-value={option.value}
                  data-attribute-name={option.name}
                  key={`dd${option.value}`}
                  className={cn(styles.option, {
                    [styles.selected]: option.selected,
                    [styles.disabled]: option.disabled,
                  })}
                  onClick={() => onClick(selector.typeName, option.value, option.productId || 1)}
                >
                  <div className={styles.content}>{option.name}</div>
                </div>
              ),
          )}
        </Dropdown>
      </div>
    </div>
  );
};

export default ProductAttributeDropdownSelectorPremium;
